export default __webpack_public_path__ + "static/media/screen_facebook_7_2.355d324e.png";